import { createApp } from 'vue';
import VueGtag from 'vue-gtag-next';
import clickOutsideFn from '@/directives/clickOutside';

import App from './App.vue';
import screens from './screens';

const app = createApp(App)
    .directive('click-outside', clickOutsideFn);

app.use(VueGtag, {
    property: {
        id: process.env.VUE_GA_ID
    }
});
app.use(screens);

app.mount('#app');
